import { useMemo } from 'react';

// 运营标签
export default function ActivityTag(props) {
  const { productVO, isHot } = props;

  return useMemo(() => {
    let labelText = '';
    if (productVO.saleRuleGroupId === 10054 && !productVO?.selfProductCode) {
      labelText = `预售商品`;
    } else if (isHot) {
      labelText = '爆款';
    }
    if (isHot && labelText === '爆款') {
      return (
        <div className="absolute z-[1] flex h-[20px] w-[40px] items-center rounded-[4px_0_10px_0] bg-[#FF4960] text-[white]">
          <span className="pl-[8px] leading-[15px] text-[white]">{labelText}</span>
        </div>
      );
    }
    if (labelText === '预售商品') {
      return (
        <div className="absolute z-[1] flex h-[20px] w-[65px] items-center rounded-[4px_0_10px_0] bg-[#00D2C5] text-[white]">
          <span className="pl-[6px] leading-[15px] text-[white]">{labelText}</span>
        </div>
      );
    }
    return <></>;
  }, [productVO, isHot]);
}
